export default "__VITE_ASSET__3bf7e112__"